import { getIconName } from 'features/stations/StationLocations/utils/getIconName';

import { Station } from 'dataSources/Typicode/stations';

import commonStation from '../assets/stationsOnRoute/commonStation.svg';
import discountStation from '../assets/stationsOnRoute/discountStation.svg';
import powerMaxStation from '../assets/stationsOnRoute/powerMaxStation.svg';
import economyStation from '../assets/stationsOnRoute/economyStation.svg';

import roadPaymentPoint from '../assets/stationsOnRoute/roadPaymentPoint.svg';
import parking from '../assets/stationsOnRoute/parking.svg';
import carWash from '../assets/stationsOnRoute/carWash.svg';
import carService from '../assets/stationsOnRoute/carService.svg';
import convoy from '../assets/stationsOnRoute/convoy.svg';
import ferryboat from '../assets/stationsOnRoute/ferryboat.svg';
import railway from '../assets/stationsOnRoute/railway.svg';
import autoPartsStore from '../assets/stationsOnRoute/autoPartsStore.svg';
import cafe from '../assets/stationsOnRoute/cafe.svg';
import truckWash from '../assets/stationsOnRoute/truckWash.svg';

const ICONS = {
  station1: commonStation,
  station2: discountStation,
  station4: powerMaxStation,
  station5: economyStation,

  roadsideService2: roadPaymentPoint,
  roadsideService3: parking,
  roadsideService4: carWash,
  roadsideService5: carService,
  roadsideService6: convoy,
  roadsideService7: ferryboat,
  roadsideService8: railway,
  roadsideService9: autoPartsStore,
  roadsideService10: cafe,
  roadsideService11: truckWash,
  roadsideService12: carService
} as Record<string, any>;

const getRouteStationIcon = (markerName: string) => (
  ICONS[markerName] ? ICONS[markerName] : ICONS.station1
);

export const getStationIconOnRoute = (station: Station) => getRouteStationIcon(getIconName({ properties: station }));
